import { AriaDatapoint } from "./AriaDatapoint";
import type { CustomData, DatapointOptions, INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, } from "owa-analytics-types";
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from "owa-analytics-events";
import type { MailboxInfo } from "owa-client-types";

/**
 * UsageDatapoint for logging telemetry events.
 *
 * @param eventName - Must be a valid event name from the data catalog (AnalyticsEventNames or AnalyticsCoreEventNames).
 *                    Using string literals that don't exist in the catalog will cause a compile error.
 * @param mailbox - The MailboxInfo for the account context, or undefined for anonymous/infrastructure events.
 */
export default class UsageDatapoint extends AriaDatapoint {
    constructor(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, customData?: CustomData, options?: DatapointOptions) {
        const usageDatapointOptions: DatapointOptions = options ?? {};
        super(eventName, mailbox, customData, usageDatapointOptions);
    }
}
